var _circle, _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "url(#paint0_linear_400_1970)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.125,
    y: 16.875,
    width: 15.75,
    height: 2.25,
    fill: "#080B2A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.125,
    y: 10.125,
    width: 15.75,
    height: 2.25,
    transform: "rotate(90 19.125 10.125)",
    fill: "#080B2A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_400_1970",
    x1: -9.96116e-8,
    y1: 20.1923,
    x2: 36.0026,
    y2: 20.0051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BD8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCFB85"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddActive);
export default __webpack_public_path__ + "static/media/addActive.6d8f770654c6e94b664917106e9ed3ee.svg";
export { ForwardRef as ReactComponent };